import { useEffect } from 'react'
import { useLocation } from 'wouter'

import { useAuth } from '../hooks/useAuth'
import { useIsModal } from '@/Router'

function parseReturnTo() {
  const search = new URLSearchParams(location.search)

  for (const [key, value] of search.entries()) {
    if (key === 'return_to') {
      return value
    }
  }
}

export const RedirectIfSignedIn: React.FC = () => {
  const { isSignedIn } = useAuth()
  const [location, navigate] = useLocation()
  const needsBackground = useIsModal()

  useEffect(() => {
    if (isSignedIn) {
      const returnTo =
        parseReturnTo()?.replace(import.meta.env.BASE_URL, '') ?? '/goodies'

      if (returnTo.startsWith('/api')) {
        window.location.href = returnTo

        return
      }

      const isModal = needsBackground(returnTo)

      // We need to make sure that we don't leave the SignIn or whatever in the background
      if (isModal) {
        navigate(returnTo, { state: { background: '/app/goodies' } })
      } else {
        navigate(returnTo)
      }
    }
  }, [location, isSignedIn, needsBackground, navigate])

  return null
}
